import * as Yup from "yup";
import {
  noSpecialCharsYupTest,
  SPECIAL_CHARS_VALIDATION_MESSAGE,
} from "../utils/inputValidation";

export const addAuthTagSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .required("tag name is required")
    .min(2, "tag name must be at least 2 characters")
    .max(50, "tag name cannot exceed 50 characters"),
  description: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .max(500, "Description cannot exceed 500 characters"),
});

export const editAuthTagSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .required("tag name is required")
    .min(2, "tag name must be at least 2 characters")
    .max(50, "tag name cannot exceed 50 characters"),
  description: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .max(500, "Description cannot exceed 500 characters"),
});
